import clientSide from "@/helpers/clientSide";

export function buildTrackingContext(params: {
  endpoint?: string;
  [key: string]: string | number | boolean | null | undefined;
}): Record<string, string> {
  const context: Record<string, string> = {};

  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      context[key] = String(value);
    }
  });

  if (clientSide && window._Cohesion?.sessionId) {
    context.CohesionSessionId = window._Cohesion.sessionId;
  }

  return context;
}

export function isEmptyOffersResponse(offers: unknown): boolean {
  return Array.isArray(offers) && offers.length === 0;
}
